import { Component, OnInit } from '@angular/core';

import { Router, ActivatedRoute } from '@angular/router';

import { UserService } from '../shared/user/user-service.service';



@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  userRights = [];
  userName = '';

  constructor(private router: Router, private activatedRoute: ActivatedRoute, private userService: UserService) {
  }

  ngOnInit() {
    this.userName = localStorage.getItem('userName');
    this.userService.getUserClaims().subscribe((data: any) => {
      this.userRights = data;
    });
  }

  Logout() {
    this.userService.logout();
  }

  isRights(value) {
      return this.userRights.find(c => c === value ) != null;
  }
}
